<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { statusLabel } from '../cardStatus';

const props = defineProps({
  status: { type: String, required: true },
  // The card's pipeline names for the statuses.
  labels: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const STYLES = {
  open: { icon: 'i-lucide-circle-dot', class: 'bg-n-blue-3 text-n-blue-11' },
  resolved: {
    icon: 'i-lucide-circle-check-big',
    class: 'bg-n-teal-3 text-n-teal-11',
  },
  canceled: { icon: 'i-lucide-circle-x', class: 'bg-n-ruby-3 text-n-ruby-11' },
};

const style = computed(() => STYLES[props.status]);
</script>

<template>
  <span
    class="inline-flex items-center h-6 gap-1 px-2 text-xs font-medium rounded-md whitespace-nowrap"
    :class="style.class"
    data-testid="card-status"
  >
    <span class="flex-shrink-0 size-3.5" :class="style.icon" />
    {{ statusLabel(labels, status, t) }}
  </span>
</template>
